"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _Portal = _interopRequireDefault(require("react-overlays/Portal"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var PopperContainer = function PopperContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_Portal.default, null, children);
};

PopperContainer.displayName = 'PopperContainer';
process.env.NODE_ENV !== "production" ? PopperContainer.propTypes = {
  children: _propTypes.default.node
} : void 0;
var _default = PopperContainer;
exports.default = _default;